// src/components/settings/Settings.js

import React, { useState, useEffect } from "react";
import "../../assets/styles/common.css";
import "./Settings.css"; // Keep this for specific settings tab styles

// Import the new tab content components
import UserSettings from "./UserSettings";
import DistributorSettings from "./DistributorSettings";
// import DefaultSettings from "./DefaultSettings";

const Settings = ({ getAuthHeaders }) => {
  const [activeTab, setActiveTab] = useState("");
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("loggedInUser");
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUserRole(userData.role);
        if (userData.role === "admin") {
          setActiveTab("user");
        } else {
          setActiveTab("distributor");
        }
      } catch (error) {
        console.error("Failed to parse user data from localStorage:", error);
        setActiveTab("distributor");
      }
    } else {
      setActiveTab("distributor");
      setUserRole("guest");
    }
  }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case "user":
        return <UserSettings getAuthHeaders={getAuthHeaders} />;
      case "distributor":
        return <DistributorSettings getAuthHeaders={getAuthHeaders} />;
      // case "default":
      //   return <DefaultSettings getAuthHeaders={getAuthHeaders} />;
      default:
        return null;
    }
  };

  if (userRole === null) {
    return <div className="settings-container">Loading settings...</div>;
  }

  return (
    <div className="settings-container">
      <h1>Settings</h1>
      <p>
        Configure your application preferences, user accounts, and system
        defaults.
      </p>
      {/* Tab Navigation */}
      <div className="settings-tabs">
        {/* Conditionally render User Management tab */}
        {userRole === "admin" && (
          <button
            onClick={() => setActiveTab("user")}
            className={`settings-tab-button ${
              activeTab === "user" ? "active" : ""
            }`}
          >
            User Management
          </button>
        )}

        <button
          onClick={() => setActiveTab("distributor")}
          className={`settings-tab-button ${
            activeTab === "distributor" ? "active" : ""
          }`}
        >
          Distributor Settings
        </button>
        {/* <button
          onClick={() => setActiveTab("default")}
          className={`settings-tab-button ${
            activeTab === "default" ? "active" : ""
          }`}
        >
          Default Settings
        </button> */}
      </div>
      {/* Render content based on active tab */}
      {renderTabContent()} {/* <--- ADD THIS LINE HERE */}
    </div>
  );
};

export default Settings;
